import React, { Component } from "react";

import validator from "validator";
import { PageMode } from "../../../../../utils/constant";

export default class Village extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }
  submit = (e) => {
    e.preventDefault();
    if (this.props.mode === PageMode.add) {

      if (
        validator.isEmpty(this.props.data.number_of_residents.value) ||
        validator.isEmpty(this.props.data.number_of_houses.value)
      ) {
        this.setState({
          error: true,
        });
        toast.error("Input Wajib Diisi tidak boleh kosong", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        this.props.nextStep();
      }
    } else {
      this.props.nextStep();
    }
  };
  render() {
    const {
      data,
      onInputChange
    } = this.props;
    return (
      <div className="form-wrapper">
        <div className="form-group">
          <label htmlFor="number_of_residents">
            Jumlah Penduduk <sup className="text-danger">*</sup>
          </label>
          <input
            type="numberOnly"
            className="form-control"
            name="number_of_residents"
            id="number_of_residents"
            placeholder="0"
            value={data.number_of_residents.value}
            onChange={onInputChange}
          />
          {data.number_of_residents && (
            <span className="text-danger">{data.number_of_residents.message}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="number_of_houses">
            Jumlah Rumah <sup className="text-danger">*</sup>
          </label>
          <input
            type="numberOnly"
            className="form-control"
            name="number_of_houses"
            id="number_of_houses"
            placeholder="0"
            value={data.number_of_houses.value}
            onChange={onInputChange}
          />
          {data.number_of_houses && (
            <span className="text-danger">{data.number_of_houses.message}</span>
          )}
        </div>
        <div className="form-action d-flex justify-content-end">
          <button
            className="btn btn-teal font-weight-bold"
            onClick={this.submit}
          >
            Selanjutnya
          </button>
        </div>
      </div>
    );
  }
}
